import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import VuetifyInit from '@/common/vuetifyInit';
import '@/bootstrap';
import Bugsnag from '@/common/Bugsnag';

// styles
import '@styles/shiftkey.scss';

window.Vue = Vue;

Vue.use(Vuetify);
Bugsnag.init();

Vue.component('ContinueInApp', () => import('@/vues/ContinueInApp.vue'));

// eslint-disable-next-line no-unused-vars
const app = new Vue({
  vuetify: VuetifyInit,
  el: '#app',
});
